/*eslint-disable */
import React, { Component, useState } from "react";
import { Table, Icon, Button, Header } from "semantic-ui-react";
import DeleteModal from "../../../components/common/deleteModal";
import { translate } from "react-i18next";
import DeleteAxios from "../../../components/axiosComponent/delete";
import cogoToast from "cogo-toast";
import AddDriverVehicle from "./addDriverVehicle";

const DriverVehicles = (props)=> {

    const {t} = props
    const [openEditModal, setOpenEditModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [currentObject , setCurrentObject] = useState()

    const openUpdateModal = (type, data)=>{
        if(type=="add"){
            setOpenEditModal(true)
        }else{
            setOpenDeleteModal(true)
        }
        setCurrentObject(data)
    }

    const closeUpdateModal = ()=>{
        setOpenEditModal(false)
        setOpenDeleteModal(false)
        setCurrentObject(null)
    }
    const deleteMapping = ()=>{
        if(currentObject && currentObject.vehicleDriverId){
            DeleteAxios({
                url : `vehicleDriver`,
                uniqueId : currentObject.vehicleDriverId
            }).then((res)=>{
                if(res?.data?.status == 200){
                    cogoToast.success(res?.data?.message, {position: "top-right"});
                    window.location.reload()
                }
            }).catch((err)=>{
                console.log(err);
            })
        }
    }
    return (
      <React.Fragment>
        <Table
          stackable
          className="animated slideInDown"
          selectable
          size="small"
        >
          <Table.Header className="w3-small">
            <Table.Row>
              <Table.HeaderCell colSpan="3">
                <Header
                  as="label"
                  size="tiny"
                  color="black"
                  className="labelName p-bold-600"
                >
                  {t('vehicles.title') || 'Vehicles'}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell colSpan="2" textAlign="right">
                <Button
                  color="blue"
                  add_mode="add"
                  onClick={()=>openUpdateModal("add", null)}
                  size="mini"
                  type="button"
                >
                  <Icon name="plus" />  {t('vehicles.add_title') || 'New'}
                </Button>
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell className="p-bold-500">
                {t('vehicles.table_header.vehicle_no') || 'Vehicle Number'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('vehicles.table_header.vehicle_type') || 'Vehicle Type'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('vehicles.table_header.ownership_type') || 'Ownership Type'}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t('vehicles.table_header.delete') || 'Delete'}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {props.mappingData && props.mappingData.length > 0 ? (
              props.mappingData.map((object, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{object.vehicleNumber}</Table.Cell>
                  <Table.Cell>{object.vehicleType}</Table.Cell>
                  <Table.Cell>{object.vehicleOwner}</Table.Cell>
                  <Table.Cell><Button type="button" onClick={()=>openUpdateModal("delete", object)} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                </Table.Row>
              ))
            ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{t("vehicles.no_records" || "No Record(s) Found")}</Table.Cell>
                </Table.Row>
              )}
          </Table.Body>
        </Table>
        <DeleteModal deleteOpen={openDeleteModal} CloseModal={closeUpdateModal} deleteItem={deleteMapping} />
        <AddDriverVehicle openModal={openEditModal} CloseModal={closeUpdateModal} driverId={props.driverId}/>
        
      </React.Fragment>
    );
}
export default translate("driver")(DriverVehicles);
